<template>
    <v-dialog v-model="dialog" width="1200">
        <v-card>
            <v-list>
                <v-list-item style="width: 100%;" class="d-flex flex-row align-end justify-end">
                    <v-text-field
                        v-model="searchText"
                        label="Pesquisa"
                        prepend-icon="mdi-magnify"
                        @input="search"
                        dense
                        class="ml-2 mr-2 align-end"
                    ></v-text-field>
                    <div class="d-flex flex-row">
                        <v-btn 
                            @click="$emit('close')"
                            style="display: flex; background-color: transparent; margin-right: 12px;">
                            Cancelar
                        </v-btn>
                        <v-btn 
                            @click="saveOs()"
                            style="display: flex; background-color: blue; margin-right: 12px; color: white !important;">
                            Salvar <v-icon style="margin-left: 4px;">mdi-check</v-icon>
                        </v-btn>
                    </div>
                </v-list-item>
            </v-list>
            <v-data-table
                v-model="selected"
                :headers="headers"
                :items="filteredItems"
                class="elevation-1"
                disable-sort
                show-select
                :single-expand="false"
            >
            </v-data-table>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: Boolean,
        osItens: Array,
        items: Array
    },
    data() {
        return {
            searchText: '',
            selected: [],
            headers: [
                { text: "Sequência", value: "sequencia", width: '100px' },
                { text: "Status", value: "status", width: '100px' },
                { text: "Item", value: "item.codigo", width: '150px' },
                { text: "Descrição", value: "descricao", width: '200px' },
                { text: "Unidade", value: "unidade.sigla", width: '150px' },
                { text: "Unidade de Compra", value: "unidadeCompra.sigla", width: '150px' },
                { text: "Quantidade", value: "quantidade", width: '100px' },
                { text: "Quantidade de Compra", value: "quantidadeCompra", width: '150px' },
                { text: "Valor Unitário", value: "precoUnitario", width: '150px' },
                { text: "Valor Total", value: "precoTotal", width: '150px' },
                { text: "Data Solicitação", value: "dataSolicitacao", width: '120px' },
                { text: "Data Necessidade", value: "dataNecessidade", width: '120px' },
                { text: "Data Entrega", value: "dataEntrega", width: '120px' },
                { text: "Fornecedor", value: "fornecedorMaterialFornecido.descricao", width: '150px' },
                { text: "Destino", value: "destino", width: '150px' },
            ],
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        },
        filteredItems() {
            if (!this.searchText) return this.items;
            return this.items.filter(item => 
                item.descricao.toLowerCase().includes(this.searchText.toLowerCase())
            );
        }
    },
    methods: {
        async saveOs() {
            this.$emit("update:osItens", this.selected);
            this.$emit("close");
        },
        async search(text) {
            this.searchText = text;
        }
    }
};
</script>
  
<style scoped>
    .style-i {
        color: white;
        font-size: 22px;
    }
    /*
    .style-i:hover {
        color: white;
    }*/

    .item-content {
        border-bottom: 1px solid rgba(172, 168, 168, 0.719);
    }

    a {
        color: black;
        margin-left: 5px;
        color: black;
    }


    span {
        float: right;
        font-size: 10px;
    }
    .card-item{
        position: relative;
    }

    .card-item:hover {
        cursor: pointer;
        background-color: whitesmoke;
    }

    .btn-aprovar, .btn-enviar-obs {
        background-color: green;
        border-radius: 15px;
        padding: 6px;
        color: white;
        font-size: 12px;
        margin: 0px 8px;
    }

    .btn-aprovar:hover, .btn-enviar-obs:hover {
        background-color: white;
        border: 1px solid green;
        color: green;
    }

    .btn-reprovar, .btn-cancelar-obs {
        background-color: red;
        border-radius: 15px;
        padding: 6px;
        color: white;
        font-size: 12px;
        margin: 0px 8px;
    }

    .btn-reprovar:hover, .btn-cancelar-obs:hover {
        background-color: white;
        border: 1px solid red;
        color: red;
    }

    .obs-container {
        margin-top: 3px;
        border: 1px solid #c5c0c0;
        padding: 5px;
    }

    .span-enviado {
        position: absolute;
        right: 15px;
        bottom: 2px;
    }

    .v-list-item__content{
        padding: 0px;
        max-height: 75px;
    }

  .img {
    margin: auto;
  }
  
  .card {
    margin-left: 500px;
  }
  
  .v-btn {
    margin-top: 15px;
  }
  
  .dialog-sobre {
    width: 500px !important;
  }
  
  .v-dialog__content {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 6;
    outline: none;
  }

  .checkbox {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  
  .v-text-field--outlined fieldset {
    border: 0;
    border-bottom: 1px solid black;
    border-radius: 0;;
  }

  .v-text-field--outlined .v-text-field__slot {
    align-items: end !important;
  }

  .v-text-field .v-input__slot {
    padding: 0 !important;
  }

  .filterInputDate {
    outline: none;
    border: 1px solid #666;
    border-radius: 4px;
    width: 269px;
    padding-left: 10px;
    font-size: 12px;
    height: 40px;
  }

  .filterInput {
    width: 30%;
    text-decoration: none !important;
    border: none !important;
  }

  ::v-deep .v-text-field__details {
    display: none !important;
  }

</style>
  